import { render, staticRenderFns } from "./dooh-delivery.vue?vue&type=template&id=49f41e8c&scoped=true"
import script from "./dooh-delivery.vue?vue&type=script&lang=js"
export * from "./dooh-delivery.vue?vue&type=script&lang=js"
import style0 from "./dooh-delivery.vue?vue&type=style&index=0&id=49f41e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f41e8c",
  null
  
)

export default component.exports